import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Inject,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  IUserGroup,
  IUserGroups,
} from 'src/app/user-management/add-user/add-user-management.interface';
import { IDeviceType, IDeviceTypes } from '../device-management.interfaces';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-device-type',
  templateUrl: './device-type.component.html',
  styleUrls: ['./device-type.component.scss'],
})
export class DeviceTypeComponent implements OnInit, AfterViewInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  deviceTypeForm!: FormGroup;
  errorMessage: string = '';
  focusOnNameModal = false;
  @Input() formGroupName!: string;
  radionButtons: IDeviceTypes | undefined;
  @ViewChild('deviceType') deviceTypeField: ElementRef | undefined;

  get formInstance() {
    return this.deviceTypeForm?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.deviceTypeForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    // radio button list manage for active status
    this.radionButtons = [
      {
        label: this.translate.instant('COMBO_READER_DEVICE'),
        value: this.translate.instant('COMBO_READER_DEVICE'),
        active: false,
      },
      {
        label: this.translate.instant('CONTROLLER_DEVICE'),
        value: this.translate.instant('CONTROLLER_DEVICE'),
        active: false,
      },
    ];

    this.radionButtons.map((deviceType: IDeviceType) => {
      if (deviceType.value === this.formInstance?.deviceType.value) {
        deviceType.active = true;
      }
    });
  }

  /**
   * @description current selected group index mark as active status
   * @param userGroup active number
   */
  activate(deviceType: IDeviceType): void {
    this.radionButtons?.map((option: any) => (option.active = false));
    deviceType.active = true;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = this.stepper - 1));
  }
  /**
   * @description navigate to next screen
   * @returns void
   */

  navigateToNextStep(): void {
    if (this.deviceTypeForm.valid) {
      this.stepperChange.emit((this.stepper = 3));
    }
  }
  ngAfterViewInit() {
    if (!this.focusOnNameModal) {
      this.focusOnNameModal = true;
      this.cdr.detectChanges();
      this.deviceTypeField?.nativeElement.focus();
    }
  }
}
